document.addEventListener('DOMContentLoaded',function(){
    
    let achordion = document.querySelectorAll('.achordion');

    const mediaQuery = window.matchMedia('(min-width: 768px)');

    achordion.forEach((target)=> {
        target.addEventListener('click', ()=>{
            if(checkMobile() === false) return;

            const elm = target.nextElementSibling;
            elm.classList.toggle('open');
            if(elm.classList.contains("open")){
                elm.style.height = elm.scrollHeight + 30 + 'px';
            }else{
                elm.style.height = "0";
            }
        })
    });


    // 高さを揃える要素
    const contactHeightAdjTargets = document.querySelectorAll('.contact_height_adj');

      
     // ページが読み込まれた時に実行
    window.addEventListener('load', function () {
      contactBoxHeightAdj(true);
    });

    
    // ウィンドウサイズを変更しても実行（ブレイクポイントの監視）
    mediaQuery.addEventListener('change', () => {
        contactBoxHeightAdj(false)
    })

      
     function contactBoxHeightAdj(is_load) {
        let is_Mobile = checkMobile();
        achordion.forEach((target)=> {
            const elm = target.nextElementSibling;

            if(is_load && is_Mobile){
                elm.classList.remove('open');
                elm.style.height = "0";
            }else{
                elm.classList.add('open');
                elm.style.height = "auto";
            }

        })
        
        if(is_Mobile === true) return;
        // 空の配列を指定。
        const contactHeightlist = [];

        for(i=0;i<contactHeightAdjTargets.length;i++){
            const height = contactHeightAdjTargets[i].offsetHeight;
            contactHeightlist.push(height);
        }

        //一番高さがある要素のheightを取得。
        const contactMaxHeight = Math.max.apply(null, contactHeightlist);



        for(i=0;i<contactHeightAdjTargets.length;i++){
            contactHeightAdjTargets[i].style.height = contactMaxHeight + 'px';
        }           

     }



    function checkMobile() {
    // デバイス幅でモバイルか判定
    if (window.matchMedia("(max-width: 767px)").matches) {
        return true;
    } else {
        return false;
    }
    }

});
